import React from 'react';
import { SEO, Banner } from '../common';
import Author from './Author';

interface BlogPostProps {
  post: any;
  pdf: any;
}

export default function BlogPost({ post, pdf }: BlogPostProps) {
  return (
    <>
      <SEO title={post.frontmatter.title} description={post.excerpt} />
      <Banner text="Reporte Imagenológico Dentomaxilofacial" />
      <div className="flex flex-col flex-wrap py-16">
        <article
          className="max-w-full lg:max-w-5xl px-4 mx-auto"
          itemScope
          itemType="http://schema.org/Article"
        >
          <header className="flex flex-col">
            <h1
              itemProp="headline"
              className="text-center font-bold text-4xl mb-4"
            >
              {post?.frontmatter?.title?.split('\\n')?.map((text) => (
                <React.Fragment key={text}>
                  {String(text)?.replace('\\n', '')?.trim()}
                  <br />
                </React.Fragment>
              ))}
            </h1>
            <div className="flex flex-col max-w-xl mx-auto">
              {post.frontmatter.authors.map((author, idx) => (
                <Author author={author} idx={idx + 1} key={idx} />
              ))}
            </div>
            {post?.frontmatter?.judge ? (
              <p className="mb-2 text-sm max-w-xl mx-auto text-gray-600">
                Editor Académico: {post?.frontmatter?.judge ?? ''}
              </p>
            ) : null}
            <h3 className="text-base mb-2 mx-auto">
              Palabras Clave:{' '}
              <span className="text-sm">
                {post.frontmatter.keywords.join(', ')}
              </span>
            </h3>
            <div className="flex flex-row flex-wrap space-x-2 justify-center">
              {post.frontmatter.showDate ? (
                <>
                  <p className="text-gray-500 text-sm mb-1">
                    Recibido {post.frontmatter.received}
                  </p>
                  <p className="text-gray-500 text-sm mb-1">
                    Aceptado {post.frontmatter.acceptance}
                  </p>
                </>
              ) : null}
              <p className="text-gray-500 text-sm mb-1">
                Publicado {post.frontmatter.published}
              </p>
            </div>
            <a
              className="text-blue-700 inline-flex items-center mt-4 cursor-pointer mx-auto"
              href={pdf?.node?.publicURL ?? null}
              download
            >
              Descargar Reporte en pdf
              <svg
                fill="currentColor"
                className="w-4 h-4 ml-2"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
          </header>
          <div
            dangerouslySetInnerHTML={{ __html: post.html }}
            className="prose text-justify mt-4 mx-auto"
            itemProp="articleBody"
          />
          <hr />
        </article>
      </div>
    </>
  );
}
